function About() {
  return (
    <section className="p-5 px-0 py-lg-6  overflow-hidden" id="about">
      <div className="container">
        <div className="row gy-5 g-lg-0 justify-content-between align-content-center flex-wrap">
          <div className="col-lg-6 d-flex  justify-content-center justify-content-lg-start   p-0 ">
            <img
              loading="lazy"
              className="rounded-4 "
              src="back.jpg"
              alt="img"
              style={{ maxWidth: "90%" }}
              data-aos="fade-up"
            />
          </div>
          <div className="col-lg-6">
            <small
              className="text-secondary fw-bold text-uppercase  fs-5"
              data-aos="fade-up"
            >
              AbOUT ME
            </small>
            <h3 className="mt-2 fs-3 fw-bolder  " data-aos="fade-up">
              A dedicated React Developer <br /> based in Zarzis, Tunisia 📍
            </h3>
            <p
              className="mt-4 text-black-50 fw-medium dark-text"
              data-aos="fade-up"
            >
              I am a Senior React Developer with over a year of experience in
              web development. With a strong foundation in JavaScript and
              extensive expertise in React, I specialize in front-end
              development tasks. My focus is on contributing to web application
              development by delivering high-quality, responsive user
              interfaces. I am dedicated to continuous learning and eager to
              tackle new challenges, striving to further enhance my skills and
              become an even more accomplished React developer.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
